export default {
  navigationBarTitleText: '验收结果'
};
